import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import CAADailyRecords from './CAADailyRecords'
import { CAADailyRecordsProvider } from './CAADailyRecords/context/CAADailyRecordsContext'
import CAAMetrics from './CAAMetrics'
import { CAAMetricsContextProvider } from './CAAMetrics/context/CAAMetricsContext'

export default function CAA({
  isManager = false,
  isPatientView = false
}: {
  isManager?: boolean
  isPatientView?: boolean
}) {
  const { t } = useTranslation()

  return (
    <Tabs
      isFitted
      w={'full'}
      p={'6'}
      pb={0}
      display={'flex'}
      flexDir={'column'}
      minH={0}
      h={'full'}
    >
      <TabList>
        <Tab>{t('caa.tabs.dailyLogs')}</Tab>
        <Tab>{t('caa.tabs.metricsTherapist')}</Tab>
        <Tab>{t('caa.tabs.metricsPatient')}</Tab>
      </TabList>
      <TabPanels flex={'1'} minH={0}>
        <TabPanel p={0} pt={'6'} overflowY={'auto'} minH={0} h={'full'}>
          <CAADailyRecordsProvider>
            <CAADailyRecords
              isManager={isManager}
              isPatientView={isPatientView}
            />
          </CAADailyRecordsProvider>
        </TabPanel>
        <TabPanel p={0} pt={'6'} overflowY={'auto'} minH={0} h={'full'}>
          <CAAMetricsContextProvider view={'OPERATIONAL-THERAPIST'}>
            <CAAMetrics />
          </CAAMetricsContextProvider>
        </TabPanel>
        <TabPanel p={0} pt={'6'} overflowY={'auto'} minH={0} h={'full'}>
          <CAAMetricsContextProvider view={'OPERATIONAL-PATIENT'}>
            <CAAMetrics />
          </CAAMetricsContextProvider>
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}
